export default __webpack_public_path__ + "media/src/assets/images/download-pdf-be264c73acdb97d3513dedb0dc7b00e3.svg";